import { useEffect } from "react";

const DEFAULT_TITLE = "Beehive Academy — Formations petite enfance fondées sur les neurosciences";

// Met à jour le titre et la meta description de la page (SEO pour SPA — Google exécute le JS).
export const Seo = ({ title, description }) => {
  useEffect(() => {
    document.title = title ? `${title} | Beehive Academy` : DEFAULT_TITLE;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description]);
  return null;
};
